import { CONSTANTS } from "../actions";
import klerData from "../apis/klerData";

const initialState = [{ id: "None", name: "Select a Location" }];

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.SET_ACTIVE_LOCATION:
      const { id, name, subOid, isAdmin } = action.payload;
      // DATABASE UPDATE
      // SESSION UPDATE
      //console.log(id);
      //console.log(isAdmin);
      localStorage.setItem("SubscriptionId", id);
      localStorage.setItem("Business", name);
      localStorage.setItem("SubscriptionOid", subOid);
      localStorage.setItem("UserIsAdmin", isAdmin);
      // console.log(localStorage.getItem("SubscriptionId"));
      const index = 0;
      const updated = state[index];
      updated.name = name;
      updated.id = id;

      let sessionData = [];
      sessionData += `{SubscriptionId@odata.bind: "Subscription(${subOid})"}`;
      klerData
        .put(`/UserSession(${localStorage.getItem("SessionId")})`, sessionData)
        .then(result => {
          // console.log(sessionData);
        })
        .catch(error => console.log(error));

      return { ...state, [index]: updated };
    default:
      return state;
  }
};

export default sessionReducer;
